/**
 * GoogleAnalyticsStrings.js
 * Created on 20-apr-2016
 * 
 * 
 * @author Reinier Feijen for Ranj
 **/

var GoogleAnalyticsStrings = {};

//Indices of custom dimensions
//	As specified for GA property (Admin > [property] > Custom Definitions > Custom Dimensions)
GoogleAnalyticsStrings.ENVIRONMENT = 1;
GoogleAnalyticsStrings.BUILD = 2;
GoogleAnalyticsStrings.LANGUAGE = 3;

GoogleAnalyticsStrings.SCENARIO = 4;
GoogleAnalyticsStrings.DIALOG = 5;
GoogleAnalyticsStrings.TOPIC = 6;

//Indices of custom metrics
//	As specified for GA property (Admin > [property] > Custom Definitions > Custom Metrics)
//GoogleAnalyticsStrings.DURATION = 1;


export default GoogleAnalyticsStrings;